import React from 'react';
import { IResourceComponentsProps } from '@refinedev/core';
import { AntdCreateInferencer } from '@refinedev/inferencer/antd';

export const NotificationCreate: React.FC<IResourceComponentsProps> = () => {
  return <AntdCreateInferencer />;
};
